module.exports = __webpack_public_path__ + "img/case5-2.877fa6f7.jpg";